import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-female",
  "use": "icon-female-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-female\">\r\n<circle cx=\"10\" cy=\"6\" r=\"5\" stroke=\"#FFBFAD\" stroke-width=\"1.5\" />\r\n<path d=\"M1 10L6 15\" stroke=\"#FFBFAD\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\r\n<path d=\"M6 10L1 15\" stroke=\"#FFBFAD\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol